<template>
	<div class="giftBox">
		<!-- <navBar>{{ title }}</navBar> -->
		<div class="content-box">
			<div class="guizi font28 df-mc" @click="goRule()">
				<img v-if="swiper.length > 0" :src="swiper[0].image" alt="" />
			</div>
			<div class="nav df-sb df-a">
				<div class="font28 df mCG navcontent" v-if="dataList.length > 0">
					<div
						class="navItem"
						:class="{ active: i == dataIndex }"
						v-for="(item, i) in dataList"
						:key="i"
						@click="dataIndex = i"
					>
						{{ item.name }}
					</div>
				</div>
				<div class="font26 df-sb mCG" :class="{ mCc: !sort }">
					芯币
					<div class="df-d df-mc" @click="(sort = !sort), sortFn()">
						<!-- <van-icon name="up" /> -->
						<!-- <van-icon name="arrow-up" /> -->
						<img :src="sort ? icon : icons" alt="" style="width: 0.3rem; margin-left: 0.08rem" />
					</div>
				</div>
			</div>
			<template v-if="dataList.length > 0">
				<div
					class="textBox"
					v-for="item in dataList[dataIndex].shoplist.data"
					:key="'ind' + item.id"
					@click="goPage(item)"
				>
					<div class="zhangList df-a df-sb">
						<div class="leftBox"><img :src="item.shopimages" alt="" /></div>
						<div class="zhangInfs df-d">
							<div class="font28 zhangName">{{ item.name }}</div>
							<div class="font24 mCG df-a biaoti">
								<div class="">{{ item.shopitem }}</div>
								<!-- <div class="">柔光护眼</div> -->
							</div>
							<div class="">
								<p class="mCc font28">
									{{ item.gold }}
									<span class="font24">芯币</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '礼品店',
			dataList: [],
			dataIndex: 0,
			swiper: [],
			sort: true,
			icon: require('@/assets/img/study/icon-18.png'),
			icons: require('@/assets/img/study/icon-18-s.png')
		};
	},
	created() {
		this.getSwiperlist();
		this.getshoplist();
	},
	methods: {
		getshoplist() {
			this.$api
				.getshoplist({
					page: 1,
					limit: 200,
					sort: this.sort ? 'desc' : 'asc',
					showToast: true
				})
				.then((res) => {
					let resData = res.data;
					this.dataList = resData;
				});
		},
		sortFn() {
			this.getshoplist();
			// 获取SVG元素
			var svgElement = document.getElementById('mx_n_1732522763756');

			// 改变填充颜色
			svgElement.querySelector('path').setAttribute('fill', 'blue');
		},
		getSwiperlist() {
			this.$api.getbannerlist({ isshop: 1 }).then((res) => {
				this.swiper = res.data;
			});
		},
		goPage(item) {
			this.$router.push({
				path: '/giftDetails',
				query: {}
			});
			this.$store.commit('common/setLianxiData1', item);
		},
		goRule() {
			this.$router.push({
				path: '/rule',
				query: {}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.giftBox {
	height: calc(100% - 0.98rem);
	padding: 0.34rem 0.28rem 0 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	overflow: auto;
	background: #fff9f6;
	.content-box {
		padding-bottom: 0.2rem;
	}
	.guizi {
		width: 100%;
		height: 3.06rem;
		background: #dbdbdb;
		border-radius: 0.2rem;
	}
	.nav {
		.navcontent {
			position: relative;
			padding: 0.28rem 0 0.28rem 0;
			.navItem {
				margin-right: 0.6rem;
				position: relative;
				&.active {
					color: #232323;
					&::after {
						opacity: 1;
					}
					font-size: 0.3rem;
				}
				&::after {
					position: absolute;
					left: 50%;
					bottom: -0.2rem;
					height: 0.08rem;
					width: 0.3rem;
					content: '';
					background: #ff7a32;
					border-radius: 0.04rem;
					opacity: 0;
					transition: all 0.3s ease-in;
					transform: translateX(-50%);
				}
			}
		}
	}
	.textBox {
		width: 100%;
		background: #ffffff;
		border-radius: 0.2rem;
		margin-top: 0.28rem;
		padding: 0.32rem;

		.zhangList {
			// margin-bottom: 0.24rem;
			.leftBox {
				width: 1.9rem;
				height: 1.9rem;
				background-color: #dbdbdb;
				border-radius: 0.1rem;

				margin-right: 0.3rem;
			}
			.zhangInfs {
				flex: 1;
				.zhangName {
					margin-bottom: 0.22rem;
				}
				.biaoti {
					margin: 0rem 0 0.2rem 0;
				
					& > div {
						padding: 0 0.1rem;
						margin-right: 0.2rem;
						font-weight: 400;
						width: auto;
						height: 0.45rem;
						color: #7c7c7c;
						background: #f8f8f8;
						border-radius: 0.04rem;
						display: flex;
						align-items: center;
					}
				}
			}
		}
	}
}
</style>
